const { NON_NUMERIC_REGEXP } = require('../constants/index');

const toCamelCase = (str) => {
    return str.replace(/[a-z\u00E0-\u00FC]\S*/gi, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};

const formatIbanString = (str) => {
    if (!str) {
        return '';
    }

    return str.match(/.{1,4}/g).join(' ')
};

const nonNumericFilter = (str = '') => {
    return str.replace(NON_NUMERIC_REGEXP, '');
};

module.exports = {
    toCamelCase,
    formatIbanString,
    nonNumericFilter,
};
